import { Case, useAdminCaseWhenBenefitsQuery } from "services/GraphQl";
import PendingReimbursementsTable from "./PendingReimbursementsTable";
import ProcessedReimbursementsTable from "./ProcessedReimbursementRequestsTable";
import ApprovedReimbursementsTable from "./ApprovedReimbursementsTable";
import WhenBenefitDetailsCard from "./WhenBenefitDetailsCard";
import MonthlyWhenBenefitsTable from "./MonthlyWhenBenefitsTable";
import { useLazyQuery } from "@apollo/client";
import { Queries } from "services/GraphQL/Queries";

const CaseWhenBenefitTab = ({ theCase }: { theCase: Case }) => {
  const { data, loading, error } = useAdminCaseWhenBenefitsQuery({
    variables: {
      companyId: theCase.companyId,
      caseId: theCase.id,
    },
  });

  const [bankInfo, bankInfoData] = useLazyQuery(Queries.getUserBankInfo);
  const showBankInfo = async () => {
    bankInfo({ variables: { userId: theCase.syncUser?.id || "" } });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!data?.case?.whenBenefit) {
    return <div>No data</div>;
  }

  const whenBenefitAllocationType = data.case.whenBenefit.distributionType;

  return (
    <div>
      <WhenBenefitDetailsCard
        whenBenefit={data.case.whenBenefit}
        showBankInfo={showBankInfo}
        bankInfoData={bankInfoData.data}
      />
      {whenBenefitAllocationType === "MONTHLY_ALLOCATION" && (
        <MonthlyWhenBenefitsTable whenBenefit={data.case.whenBenefit} />
      )}
      <PendingReimbursementsTable
        whenBenefit={data.case.whenBenefit}
        caseId={theCase.id}
        companyId={theCase.companyId}
      />
      <ApprovedReimbursementsTable
        whenBenefit={data.case.whenBenefit}
        caseId={theCase.id}
        companyId={theCase.companyId}
      />
      <ProcessedReimbursementsTable whenBenefit={data.case.whenBenefit} />
    </div>
  );
};

export default CaseWhenBenefitTab;
